import { cn } from '@utils/cn';

import { linkVariants } from './Link.styles';
import type { LinkProps } from './Link.types';

/**
 * NOTE: Always wrap in text component for correct font size, family etc
 */

export const Link = ({
  children,
  onClick,
  href,
  underline = false,
  target,
  className,
  tabIndex = 0,
  ...props
}: LinkProps) => {
  const click = onClick ? onClick : () => {};

  return (
    <a
      target={target}
      href={href}
      onClick={(e) => click(e)}
      className={cn(linkVariants({ underline }), className)}
      tabIndex={tabIndex}
      {...props}
    >
      {children}
    </a>
  );
};
